module.exports = __webpack_public_path__ + "img/filterImage_dark.301a499c.png";